var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragHorz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0886 38.6702L24.9286 36.8424L20.937 32.8508L31.5068 32.8508L31.5068 30.2707L20.937 30.2707L24.9286 26.279L23.0886 24.4512L15.9953 31.5607L23.0886 38.6702Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.43 24.4512L39.5899 26.2789L43.5815 30.2706L33.0117 30.2706V32.8507H43.5815L39.5899 36.8423L41.43 38.6701L48.5233 31.5606L41.43 24.4512Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHorz);
export default __webpack_public_path__ + "static/media/dragHorz.30d37b16.svg";
export { ForwardRef as ReactComponent };